import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Welcome from './components/Welcome';
import Artwork from './components/Artwork';
import JavascriptProjects from './components/JavascriptProjects';
import StyleProjects from './components/StyleProjects';


import './custom_css/main.css';
import './custom_css/welcomeAndArt.css';
import './custom_css/gridProjects.css';
import './custom_css/negativeSpace.css';
import './custom_css/animated_designs.css';
import './custom_css/games.css';


const App = () => {

  return (
    <div className="App">

      <Navbar />

      <div className="mainContent">

        {/* this stuff hash routed */}
        <Switch>
          <Route exact path='/' component={Welcome} />
          <Route path='/javascript' component={JavascriptProjects} />
          <Route path='/css' component={StyleProjects} />
          <Route path='/artwork' component={Artwork} />
          <Route component={ ()=>{ return (<div>404 - Page not Found</div>) }} />
        </Switch>

      </div>

      <Footer />

    </div>
  );
}




export default App;
